import { FC } from "react";
import { Chip, useTheme } from "@mui/material";
import type { Theme } from "@mui/material";

/**
 * Zammad's default priority ids: 1 low, 2 normal, 3 high. Falls back to the
 * "normal" palette for any other id since the backend allows custom priorities.
 */
const getPriorityPalette = (theme: Theme, priorityId: number) => {
  if (priorityId === 1) return theme.palette.alert_success;
  if (priorityId === 3) return theme.palette.alert_error;
  return theme.palette.alert_warning;
};

interface TicketPriorityChipProps {
  priority: string;
  priorityId: number;
}

const TicketPriorityChip: FC<TicketPriorityChipProps> = ({
  priority,
  priorityId,
}) => {
  const theme = useTheme();
  const palette = getPriorityPalette(theme, priorityId);

  return (
    <Chip
      label={priority || "-"}
      size="small"
      sx={{
        backgroundColor: palette.light,
        height: "22px",
        borderRadius: "4px",
        width: "fit-content",
        "& .MuiChip-label": {
          color: palette.main,
          fontWeight: 500,
          fontSize: "0.75rem",
          px: 1,
        },
      }}
    />
  );
};

export default TicketPriorityChip;
